import Skeleton from "../../../components/Skeleton/Skeleton";
import useScreenSize from "../../../hooks/useScreenSize";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  return (
    <div className="flex flex-col gap-4">
      {!isMobile && (
        <div className="flex flex-col gap-1 mb-2">
          <Skeleton width="80px" height="32px" />
          <Skeleton width="180px" height="20px" />
        </div>
      )}

      {/* User card */}
      <div className="rounded-xl border border-[#EBEBEB] p-6 flex flex-col items-center gap-4">
        <Skeleton width="64px" height="64px" borderRadius="50%" />
        <Skeleton width="180px" height="24px" />
      </div>

      {/* Personal data card */}
      <div className="rounded-xl border border-[#EBEBEB] p-6 flex flex-col gap-6">
        <Skeleton width="160px" height="24px" />
        <div className="flex items-center gap-4">
          <Skeleton width="24px" height="24px" borderRadius="50%" />
          <div className="flex flex-col gap-1.5 flex-1">
            <Skeleton width="40px" height="12px" />
            <Skeleton width="220px" height="16px" />
          </div>
        </div>
      </div>

      {/* About card */}
      <div className="rounded-xl border border-[#EBEBEB] p-6 flex flex-col gap-6">
        <Skeleton width="100px" height="24px" />
        <div className="flex items-center justify-between">
          <Skeleton width="120px" height="12px" />
          <Skeleton width="80px" height="16px" />
        </div>
      </div>
    </div>
  );
};

export default PageSkeleton;
